export const NavigationMessages = Object.freeze({
	slideDoesNotExists: 'Oops, slide does not exists',
	canNotNavigate: "Oops, you can't navigate to selected slide. Please, try to navigate progressively"
});
